export default "__VITE_ASSET__BQ_D3tur__"